import { UserFullName } from '../../commonTypes/NotificationTypes/notification.types';
import { Translation } from '../../commonTypes/translation.types';

export class TranslationFormatter {
    protected data?: Translation;

    constructor(data?: Translation) {
        this.data = data;
    }

    public getTranslation(translation: keyof Translation, replacements?: Record<string, unknown>): string {
        try {
            if (!this.data) throw new Error('Missing data');

            const keys = (translation as string).split('.');
            let result = this.data as any;

            for (const element of keys) {
                result = result[element];
                if (!result) break;
            }

            if (typeof result !== 'string') throw new Error('Result is not a string');
            if (replacements) return this.replacePlaceholders(result, replacements);
            return result;
        } catch (e) {
            console.log('Error in translation for key', translation, e);
            return translation ?? '...';
        }
    }

    private replacePlaceholders(template: string, replacements: Record<string, unknown>): string {
        const regex = /{{(.*?)}}/g;
        return template.replace(regex, (_, key) => {
            return key in replacements ? `${replacements[key] as string}` : `{{${key}}}`;
        });
    }

    public formatFieldName(fieldName: string): string {
        return fieldName.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase());
    }

    public getFullName(user?: Partial<UserFullName> | null): string {
        if (!user) return '';

        return [user.givenName, user.familyName].filter(Boolean).join(' ');
    }

    public generateTitle(title: string): string {
        return this.getTranslation('notifications', { title: title });
    }
}
